import { render, staticRenderFns } from "./IncomeMiniProgram.vue?vue&type=template&id=34a49763&scoped=true"
import script from "./IncomeMiniProgram.vue?vue&type=script&lang=js"
export * from "./IncomeMiniProgram.vue?vue&type=script&lang=js"
import style0 from "./IncomeMiniProgram.vue?vue&type=style&index=0&id=34a49763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a49763",
  null
  
)

export default component.exports